import React from 'react';
import { bool, func } from 'prop-types';
import { NotifyTypo, NotifyIcon } from 'web-components';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { StyledButton, StyledContent, StyledNewDialog } from './elements';

const labelAmmend = 'machines.machine_details.error_code_modal';

const AddSensor = ({ open, handleClose, handleCustomSensor, handlePreDefinedSensor }) => {
  const { t } = useTranslation();

  return (
    <StyledNewDialog
      open={open}
      handleClose={handleClose}
      title={t(`${labelAmmend}.title`)}
      subTitle={t(`${labelAmmend}.subtitle`)}
      displayActionBar="none"
      maxWidth="680px"
      content={
        <StyledContent>
          <StyledButton onClick={() => handlePreDefinedSensor()}>
            <NotifyIcon iconName="preDefIcon" fontSize="medium" sx={{ mx: 2 }} />
            <Box>
              <NotifyTypo.Body1 color="text.primary">
                <strong>{t(`${labelAmmend}.pre_def_title`)}</strong>
              </NotifyTypo.Body1>
              <NotifyTypo.Subtitle1 color="text.primary" fontWeight="normal">
                {t(`${labelAmmend}.pre_def_subtitle`)}
              </NotifyTypo.Subtitle1>
            </Box>
          </StyledButton>

          <StyledButton onClick={() => handleCustomSensor()}>
            <NotifyIcon iconName="customIcon" fontSize="medium" sx={{ mx: 2 }} />
            <Box>
              <NotifyTypo.Body1 color="text.primary">
                <strong>{t(`${labelAmmend}.custom_title`)}</strong>
              </NotifyTypo.Body1>
              <NotifyTypo.Subtitle1 color="text.primary" fontWeight="normal">
                {t(`${labelAmmend}.custom_subtitle`)}
              </NotifyTypo.Subtitle1>
            </Box>
          </StyledButton>
        </StyledContent>
      }
    />
  );
};

AddSensor.propTypes = {
  open: bool.isRequired,
  handleClose: func.isRequired,
  handleCustomSensor: func.isRequired,
  handlePreDefinedSensor: func.isRequired
};

export default AddSensor;
